"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCTA = void 0;
var _useUserSessionStatus = require("../user/useUserSessionStatus");
var _constants = require("../../utils/constants");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _react = require("react");
var _services = require("../../services");
var _useGuidedSellingStatus = require("./useGuidedSellingStatus");
var _useConfig = _interopRequireDefault(require("../useConfig"));
var _userActions = require("../../store/user/userActions");
var _userSelectors = require("../../store/user/userSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useCTA = () => {
  const {
    userSessionJourneyStatus,
    isUserSessionFinalized
  } = (0, _useUserSessionStatus.useUserSessionStatus)();
  const {
    openGuidedSellingModal
  } = (0, _useGuidedSellingStatus.useGuidedSellingStatus)();
  const marketingId = (0, _useAppSelector.useAppSelector)(_userSelectors.selectMarketingId);
  const bufferSessionCreation = (0, _useConfig.default)('settings.bufferSessionCreation', false);
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const CTASettings = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectCTASettings);
  const showCTADelay = (CTASettings === null || CTASettings === void 0 ? void 0 : CTASettings.showRibbonDelay) * 1000;
  const showExtendedCTADelay = (CTASettings === null || CTASettings === void 0 ? void 0 : CTASettings.showPopUp) * 1000;
  const showModifiedRibbon = CTASettings === null || CTASettings === void 0 ? void 0 : CTASettings.showModifiedRibbon;
  const appearance = CTASettings.Appearance;
  const content = {
    ribbonText: _services.locale.localeString('EntryPoint.RibbonText'),
    floatingButtonText: _services.locale.localeString('EntryPoint.FloatingButtonText'),
    popupTitle: _services.locale.localeString('EntryPoint.PopUpTitle'),
    popupText: '',
    popupCancelButtonText: _services.locale.localeString('EntryPoint.CancelButtonText'),
    popupOkButtonText: '',
    inFlowButtonText: _services.locale.localeString('EntryPoint.InflowButtonText'),
    bannerText: _services.locale.localeString('EntryPoint.BannerText') || 'What are you looking for today?'
  };
  const [showExtendedCTA, setShowExtendedCTA] = (0, _react.useState)(false);
  const [showCTA, setShowCTA] = (0, _react.useState)(false);
  const onClickCTA = (0, _react.useCallback)(() => {
    openGuidedSellingModal();
    if (bufferSessionCreation && !isUserSessionFinalized) {
      dispatch((0, _userActions.createUserSession)(marketingId));
    }
    if (userSessionJourneyStatus === _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_RECOMMENDATION) {
      dispatch((0, _recommendationActions.reopenRecommendation)());
    }
  }, [isUserSessionFinalized, bufferSessionCreation, openGuidedSellingModal, dispatch, _userActions.createUserSession, marketingId, userSessionJourneyStatus]);
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      setShowCTA(true);
    }, showCTADelay);
  }, []);
  (0, _react.useEffect)(() => {
    if (showCTA === true) {
      const openExtendedFloating = setTimeout(() => {
        setShowExtendedCTA(true);
      }, showExtendedCTADelay);
      const mousedownListener = () => {
        clearTimeout(openExtendedFloating);
      };
      document.addEventListener('mousedown', mousedownListener);
      return () => {
        document.removeEventListener('mousedown', mousedownListener);
      };
    }
  }, [showCTA]);
  switch (userSessionJourneyStatus) {
    case _constants.USER_SESSION_JOURNEY_STATUS.NEW_USER:
    case _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_START:
      {
        content.popupText = _services.locale.localeString('EntryPoint.NewUserText');
        content.popupOkButtonText = _services.locale.localeString('EntryPoint.NewUserButtonText');
        break;
      }
    case _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_QUESTIONNAIRE:
      {
        content.popupText = _services.locale.localeString('EntryPoint.ReturningUserText');
        content.popupOkButtonText = _services.locale.localeString('EntryPoint.ReturningUserButtonText');
        break;
      }
    case _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_RECOMMENDATION:
      {
        content.ribbonText = _services.locale.localeString('EntryPoint.RecommendationRibbonText');
        content.popupTitle = _services.locale.localeString('EntryPoint.RecommendationTitle');
        content.popupText = _services.locale.localeString('EntryPoint.RecommendationPopUp');
        content.popupOkButtonText = _services.locale.localeString('EntryPoint.RecommendationPopUpOkButton');
        break;
      }
  }
  return {
    content,
    appearance,
    showCTA,
    showExtendedCTA,
    showModifiedRibbon,
    onClickCTA
  };
};
exports.useCTA = useCTA;